import { createElement, useEffect, useState } from 'react';
import { SHARE_TOKEN } from './shareLink';
import { reportError } from './telemetry';

/* Code the signed-in screen renders, but that the first paint does not need, kept
   out of the main bundle so main downloads and runs sooner — and with it the
   /auth/me check, which only starts once main has run.

   The chunk starts downloading as soon as this module is evaluated (at startup),
   so it arrives while the app is still waiting on /auth/me over the ~250 ms link:
   time the link is idle anyway. By the time the screen renders, the code is
   normally there and draws synchronously, with no Suspense fallback flashing.

   Not for pages (they use lazyPage() in App.js, which also recovers from chunks a
   deploy deleted — not a concern here: these load with the page itself). A share
   link (/p/<token>) never shows the signed-in app, so it does not download them. */

export function preloadModule(load) {
  const entry = { mod: null, promise: null };
  entry.start = () => {
    if (!entry.promise) {
      entry.promise = load().then(
        (mod) => { entry.mod = mod; return mod; },
        (err) => { reportError('chunk_error', err?.message, { preload: true }); },
      );
    }
    return entry.promise;
  };
  if (!SHARE_TOKEN) entry.start();
  return entry;
}

/* A component that renders `entry`'s export `name` once it is loaded, and `fallback`
   (nothing, by default) until then — or for good, if the chunk failed to load. */
export function deferred(entry, name = 'default', fallback = null) {
  function Deferred(props) {
    const [, setLoaded] = useState(Boolean(entry.mod));
    useEffect(() => {
      let live = true;
      entry.start().then(() => { if (live && entry.mod) setLoaded(true); });
      return () => { live = false; };
    }, []);
    const Component = entry.mod?.[name];
    return Component ? createElement(Component, props) : fallback;
  }
  Deferred.displayName = `Deferred(${name})`;
  return Deferred;
}
